import type { FunctionComponent } from 'react';
import styled from 'styled-components';
import { paletteHelper, spacingHelper } from '@property.com.au/ui-kit';
import { DefineAdSlot } from '../../../../../app-kit/components/DefineAdSlot/DefineAdSlot';
import { mapSlotConfigFromVariant } from './helpers/mapSlotConfigFromVariant';
import { isHopefullyDomEnvironment } from '../../../../../helpers/IsHopefullyDomEnvironment';
import { usePropertyPageQuery } from '../../../../graphql/usePropertyPageQuery';

const minWidthPx = 1280;
const minHeightPx = 608;
const adWidthPx = 160;
const adHeightPx = 600;

const AdvertisementContainer = styled.div`
  display: none;

  @media (min-width: ${minWidthPx}px) and (min-height: ${minHeightPx}px) {
    flex-shrink: 0;
    flex-grow: 0;
    width: calc(${adWidthPx}px + ${spacingHelper('large')} * 2);
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-left: 1px solid ${paletteHelper('borderPrimary')};
    /* adding 1px transparent border right so content is still centered */
    border-right: 1px solid transparent;
  }
`;

const SlotWrapper = styled.div`
  width: ${adWidthPx}px;
  height: ${adHeightPx}px;
  background-color: ${paletteHelper('backgroundSecondaryInvertedStatic')};
`;

export const MediaGalleryDesktopAd: FunctionComponent = () => {
  const propertyPageBySlugData = usePropertyPageQuery()?.data?.propertyPageBySlugV3;
  const desktopAd = propertyPageBySlugData?.mediaGalleryV2?.desktopAd;

  if (
    !desktopAd ||
    !isHopefullyDomEnvironment() ||
    window.innerWidth < minWidthPx ||
    window.innerHeight < minHeightPx
  ) {
    return null;
  }

  return (
    <AdvertisementContainer data-testid="MediaGalleryDesktopAd">
      <SlotWrapper>
        <DefineAdSlot slotConfig={mapSlotConfigFromVariant(desktopAd.variant)} />
      </SlotWrapper>
    </AdvertisementContainer>
  );
};
